import { useState, useEffect } from 'react';

const NAV_LINKS = [
  { label: 'About', href: '#about' },
  { label: 'Mission', href: '#mission' },
  { label: 'Services', href: '#services' },
  { label: 'Clients', href: '#clients' },
  { label: 'Our Work', href: '#ourwork' },
  { label: 'Contact', href: '#contact' },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', fn, { passive: true });
    return () => window.removeEventListener('scroll', fn);
  }, []);

  return (
    <nav data-testid="nav-container" className={`nav${scrolled ? ' scrolled' : ''}`}>
      <div className="nav-inner">
        <a data-testid="nav-logo" href="#" className="nav-logo" aria-label="Talking Talent Home">
          <img
            src="https://customer-assets.emergentagent.com/job_coaching-platform-59/artifacts/zi17ndy5_Talking%20Talent%20Logo-01.png"
            alt="Talking Talent"
            className="logo-img"
          />
        </a>
        <ul data-testid="nav-links" className="nav-links">
          {NAV_LINKS.map(({ label, href }) => (
            <li key={href}>
              <a href={href}>{label}</a>
            </li>
          ))}
          <li>
            <a
              data-testid="nav-cta-button"
              href="#contact"
              className="nav-cta-pill"
            >
              Contact Us
            </a>
          </li>
        </ul>
        <button
          className="nav-mobile-toggle"
          onClick={() => setOpen(o => !o)}
          aria-label="Menu"
        >
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
            {open ? (
              <>
                <line x1="3" y1="3" x2="19" y2="19" stroke="#000" strokeWidth="1.5" strokeLinecap="round"/>
                <line x1="19" y1="3" x2="3" y2="19" stroke="#000" strokeWidth="1.5" strokeLinecap="round"/>
              </>
            ) : (
              <>
                <line x1="3" y1="7" x2="19" y2="7" stroke="#000" strokeWidth="1.5" strokeLinecap="round"/>
                <line x1="3" y1="12" x2="19" y2="12" stroke="#000" strokeWidth="1.5" strokeLinecap="round"/>
                <line x1="3" y1="17" x2="19" y2="17" stroke="#000" strokeWidth="1.5" strokeLinecap="round"/>
              </>
            )}
          </svg>
        </button>
      </div>
      {open && (
        <div className="nav-mobile-menu">
          {NAV_LINKS.map(({ label, href }) => (
            <a key={href} href={href} onClick={() => setOpen(false)}>{label}</a>
          ))}
          <a href="#contact" className="btn-black" style={{ alignSelf: 'flex-start' }} onClick={() => setOpen(false)}>
            Contact Us
          </a>
        </div>
      )}
    </nav>
  );
}
